export interface DemoOption {
  id: string;
  label: string;
  description: string;
  bookingUrl: string;
}

export const DEMO_OPTIONS: DemoOption[] = [
  {
    id: 'english-hindi',
    label: 'English / Hindi',
    description: 'A live walkthrough with our team, in English or Hindi.',
    bookingUrl: 'https://app.wenext.ai/book/english-hindi-demos',
  },
  {
    id: 'telugu',
    label: 'Telugu',
    description: 'The same walkthrough of the WeNext platform, in Telugu.',
    bookingUrl: 'https://app.wenext.ai/book/wenext-platform-walkthrough',
  },
];

export const PLANS_URL = '/home/billing?tab=plans';

export function validateSandboxLinks(options: DemoOption[] = DEMO_OPTIONS): string[] {
  const problems: string[] = [];
  const ids = new Set<string>();

  if (!/^\/home\//.test(PLANS_URL)) {
    problems.push(`PLANS_URL is not an in-app /home/ route ("${PLANS_URL}")`);
  }

  for (const option of options) {
    if (ids.has(option.id)) problems.push(`duplicate demo option id "${option.id}"`);
    ids.add(option.id);

    if (!/^https:\/\/[^/]+\/book\/[^/?#]+/.test(option.bookingUrl)) {
      problems.push(
        `demo option "${option.id}" does not point at an https /book/<slug> page ` +
          `("${option.bookingUrl}") — see the note at the top of sandboxLinks.ts`,
      );
    }
  }

  return problems;
}
